import type { IAward } from '~/types/UserData'
import { useUserStore } from '~/stores/user'
const useAwards = async (data: any): Promise<{ award: IAward | {}; newAward: boolean }> => {
  const userStore = useUserStore()

  const newAward = ref(false)
  const awards = [
    {
      title: 'Djurvän',
      icon: 1,
      text: 'Ditt första pris - grattis! Fortsätt med ditt fantastiska jobb för fler fina utmärkelser. Du är bäst!',
      rule: data?.score >= 5,
    },
    {
      title: 'Djurbästis',
      icon: 2,
      text: 'Nu är du en djurbästis - vilken grej! Tack för att du fortsätter att göra skillnad för djuren.',
      rule: data?.score >= 15,
    },
    {
      title: 'Djurbeskyddare',
      icon: 3,
      text: 'Nu har du förtjänat utmärkelsen djursbeskyddare - heja dig!',
      rule: data?.score >= 30 && data?.weekScore?.score >= 2,
    },
    {
      title: 'Djurkämpe',
      icon: 4,
      text: 'Grattis Djurkämpe! Ge dig själv en klapp på axeln - du förtjänar det.',
      rule: data?.score >= 60 && data?.weekScore?.score >= 3,
    },
    {
      title: 'Djurhjälte',
      icon: 5,
      text: 'Grattis! Nu har du nått den högsta utmärkelsen i Blixtappen! Tack för att du är en hjälte för djuren.',
      rule: data?.score >= 100 && data?.weekScore?.score >= 4,
    },
  ]
  const filteredAward = awards
    .filter(a => !!a.rule)
    .map(a => ({
      icon: a.icon,
      title: a.title,
      text: a.text,
    }))

  const award = filteredAward?.length ? filteredAward[filteredAward.length - 1] : ({} as IAward)

  const oldAward = userStore.getAward

  if ('icon' in award && award?.icon) {
    if (oldAward?.icon !== award?.icon) {
      await userStore.setAward(award)
      newAward.value = true
    }
  }

  return {
    award,
    newAward: newAward.value,
  }
}

export default useAwards
